<div class="calendar-month">
  <div class="weekdays">
    <div class="weekend-color">
      <tidy-text class="day-text" [body]="language && language !== 'en' ? (('Sunday' | translate) | slice:0:3) : 'Sun'" />
    </div>
    <div>
      <tidy-text [body]="language && language !== 'en' ? (('Monday' | translate) | slice:0:3) : 'Mon'" />
    </div>
    <div>
      <tidy-text [body]="language && language !== 'en' ? (('Tuesday' | translate) | slice:0:3) : 'Tues'" />
    </div>
    <div>
      <tidy-text [body]="language && language !== 'en' ? (('Wednesday' | translate) | slice:0:3) : 'Wed'" />
    </div>
    <div>
      <tidy-text [body]="language && language !== 'en' ? (('Thursday' | translate) | slice:0:3) : 'Thu'" />
    </div>
    <div>
      <tidy-text [body]="language && language !== 'en' ? (('Friday' | translate) | slice:0:3) : 'Fri'" />
    </div>
    <div class="weekend-color">
      <tidy-text class="day-text" [body]="language && language !== 'en' ? (('Saturday' | translate) | slice:0:3) : 'Sat'" />
    </div>
  </div>
  @if (isEnhancedView) {
    <!-- Enhanced monthly view (3 or fewer properties): week rows with one
         swim lane per property. Reservations span their full date range as
         bars styled like the weekly view's reservation cards; jobs sit in
         the owning property's lane below, so bars never overlap jobs or
         other reservations. -->
    <div class="enhanced-days">
      @for (week of enhancedWeeks; track week.days[0].fullDate) {
        <div class="week-row">
          <div class="week-bg">
            @for (day of week.days; track day.fullDate) {
              <div
                class="day-bg"
                [class.weekend-background]="day.isWeekend"
                (click)="onClickDay(day)"></div>
            }
          </div>
          <div class="week-content">
            <div class="day-numbers">
              @for (day of week.days; track day.fullDate) {
                <div
                  [class]="
                    'day-number' +
                    (day.otherMonth ? ' other-month' : '') +
                    (day.isWeekend ? ' weekend-color' : '')">
                  <div class="day-label">
                    @if (day.date === 1) {
                      <tidy-text
                        style="margin-right: 5px;"
                        class="day-text"
                      [body]="day.shortMonth + ' '" />
                    }
                    @if (day.isToday) {
                      <div class="today-background-container">
                        <div class="today-background"></div>
                        <tidy-text class="day-text" [body]="day.date" />
                      </div>
                    } @else {
                      <tidy-text class="day-text" [body]="day.date" />
                    }
                  </div>
                </div>
              }
            </div>
            @if (isLoading && week.lanes.length === 0) {
              <div class="lane-skeleton">
                <ion-skeleton-text
                  animated="true"
                  style="
                    height: 18px;
                    border-radius: 9px;
                    width: 60%;
                  " />
              </div>
            }
            @for (lane of week.lanes; track lane.propertyId) {
              <div class="lane">
                @if (lane.segments.length > 0) {
                  <div class="lane-bars">
                    @for (segment of lane.segments; track segment.key) {
                      @if (segment.reservation) {
                        <app-reservation-bar
                          [reservation]="segment.reservation"
                          [address]="lane.address"
                          [addressId]="lane.propertyId"
                          [continuesLeft]="segment.continuesLeft"
                          [continuesRight]="segment.continuesRight"
                          [showLabel]="windowWidth >= 820"
                          [style.grid-column]="segment.colStart + ' / ' + segment.colEnd"
                          [style.grid-row]="segment.row" />
                      } @else {
                        <app-owner-block-card
                          variant="bar"
                          [block]="segment.block"
                          [address]="lane.address"
                          [showLabel]="windowWidth >= 820"
                          [style.grid-column]="segment.colStart + ' / ' + segment.colEnd"
                          [style.grid-row]="segment.row" />
                      }
                    }
                  </div>
                }
                @if (lane.jobCells.length > 0) {
                  <div class="lane-jobs">
                    @for (cell of lane.jobCells; track cell.dayIndex) {
                      <div class="lane-jobs-day" [style.grid-column]="cell.dayIndex + 1">
                        @for (chip of cell.chips; track chip.key) {
                          <div
                            class="job-container"
                            [attr.id]="cell.day.popupLeft ? 'hover-trigger-left' : 'hover-trigger-right'"
                            (click)="onClickLaneJob(chip.job, $event)">
                            <div class="align-center">
                              <div>
                                @if (chip.job?.status?.icon_type === 'image') {
                                  <tidy-image
                                    [src]="chip.job?.status?.icon"
                                    style="height: 15px" />
                                }
                              </div>
                              @if (chip.job?.status?.icon_type === 'initials') {
                                <div
                                  [ngStyle]="chip.job?.status?.status === 'on_the_way' || chip.job?.status?.status === 'arrived_at_home' ? {'margin-right': '8px'} : {}">
                                  <tidy-initials-icon
                                    [size]="'small'"
                                    [fullName]="chip.job?.title || chip.job?.homekeeperName || 'BA'" />
                                </div>
                              }
                              <tidy-text
                                [ngStyle]="{'margin-left': chip.job?.status?.class === 'pro-initials-in-progress' ? '5px' : '0px'}"
                                [body]="windowWidth <= 1330 ? (chip.label | truncate: jobNameTruncateLength) : chip.label" />
                            </div>
                            <div class="popup" id="popup-content">
                              <div class="popup-content">
                                <div class="container vertical-align-center">
                                  <tidy-image [src]="chip.job?.icon" class="body-size" />
                                  <tidy-text
                                    [header]="chip.job?.object?.service_name || chip.job?.object?.service_type_details?.name" />
                                </div>
                                <div class="divider"></div>
                                <div class="container">
                                  <tidy-text
                                  [body]="chip.job?.parsedRequestTimes ? chip.job?.parsedRequestTimes : ((chip.job?.date | translate) + ' ' + (chip.job?.time | translate))" />
                                </div>
                                @if (chip.job?.homekeeperNames) {
                                  <div
                                    class="container bullet-item"
                                    >
                                    <tidy-text [body]="chip.job?.homekeeperNames" />
                                  </div>
                                } @else {
                                  @if (chip.job?.object?.homekeeper?.name) {
                                    <div
                                      class="container bullet-item"
                                      >
                                      <tidy-text
                                      [body]="chip.job?.object?.homekeeper?.name" />
                                    </div>
                                  }
                                }
                                <div class="container bullet-item">
                                  <tidy-text
                                  [body]="chip.job?.address?.address_name || chip.job?.address?.address1" />
                                </div>
                                <div class="container bullet-item">
                                  <tidy-text
                                  [body]="chip.job?.status?.name | titlecase" />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
  <div class="days" [style.--row-count]="days.length / 7">
    @for (day of days; track day) {
      <div
        [class]="
          (day.otherMonth ? 'day other-month' : 'day') +
          (day.isWeekend ? ' weekend-color weekend-background' : '')"
        (click)="onClickDay(day)">
        <div class="day-header">
          <div class="month-label">
            @if ((day.filteredReservations?.length === 0 && isLoading && !day.otherMonth)) {
              <div style="margin-left: 5px;">
                <ion-skeleton-text
                  animated="true"
                  style="
                    height: 22px;
                    border-radius: 10px;
                    width: 100px;
                  " />
              </div>
            }
            @if (day.reservationInfo?.starting > 0 || day.reservationInfo?.ending > 0) {
              <div
                [class]="!day.isWeekend ? 'reservation-container' : 'reservation-container reservation-weekend'"
                [attr.id]="day.popupLeft ? 'hover-trigger-left' : 'hover-trigger-right'"
                (click)="onClickReservation(day)">
                <div class="align-center">
                  <div>
                    <tidy-image
                      class="custom-calendar-link-icon"
                    [src]="'assets/img/calendar-link.svg'" />
                  </div>
                  <div>
                    @if (windowWidth >= 820 && (windowWidth < 1070 && day.date !== 1 || windowWidth >= 1070)) {
                      <tidy-text [body]="windowWidth <= 1245 ? (day.reservationText | truncate: 5) : day.reservationText" />
                    }
                    <div
                      [class]="!day.isFirstWeek ? 'popup' : 'popup popup-first-week'"
                      id="popup-content">
                      <div class="popup-content">
                        <div class="container vertical-align-center">
                          <tidy-image
                            class="custom-calendar-link-icon"
                            [src]="'assets/img/calendar-link.svg'" />
                          <tidy-text [header]="'Reservations'" />
                        </div>
                        <div class="divider"></div>
                        @for (reservation of day.filteredReservations | slice: 0:4; track reservation; let i = $index) {
                          <div
                            [class]="i === 0 ? 'container' : 'container bullet-item'">
                            <tidy-text
                              [body]="'• ' + reservation?.guestName || reservation?.title" />
                            @if (reservation?.guestName && reservation?.title) {
                              <tidy-text
                                [helper]="' (' + reservation.title + ')'" />
                            }
                            @if (reservation?.sourceName) {
                              <tidy-text
                                [helper]="' • ' + reservation.sourceName" />
                            }
                          </div>
                        }
                        @if (day.filteredReservations?.length > 4) {
                          <div class="container bullet-item">
                            <tidy-text
                            [body]="'+' + day.filteredReservations?.length - 4 + (' more' | translate)" />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (day.filteredInquiries?.length > 0) {
              <div
                class="inquiry-container"
                [attr.id]="day.popupLeft ? 'hover-trigger-left' : 'hover-trigger-right'"
                (click)="onClickInquiry(day)">
                <div class="align-center">
                  <span class="inquiry-month-chip">{{ day.inquiryText }}</span>
                  <div
                    [class]="!day.isFirstWeek ? 'popup' : 'popup popup-first-week'"
                    id="popup-content">
                    <div class="popup-content">
                      <div class="container vertical-align-center">
                        <span class="custom-inquiry-icon"></span>
                        <tidy-text [header]="'Inquiries'" />
                      </div>
                      <div class="divider"></div>
                      @for (inquiry of day.filteredInquiries | slice: 0:4; track inquiry; let i = $index) {
                        <div
                          [class]="i === 0 ? 'container' : 'container bullet-item'">
                          <tidy-text
                            [body]="'• ' + (inquiry?.guestName || inquiry?.title)" />
                          @if (inquiry?.guestName && inquiry?.title) {
                            <tidy-text
                              [helper]="' (' + inquiry.title + ')'" />
                          }
                          @if (inquiry?.sourceName) {
                            <tidy-text
                              [helper]="' • ' + inquiry.sourceName" />
                          }
                        </div>
                      }
                      @if (day.filteredInquiries?.length > 4) {
                        <div class="container bullet-item">
                          <tidy-text
                          [body]="'+' + (day.filteredInquiries.length - 4) + (' more' | translate)" />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="day-label">
            @if (day.date === 1) {
              <tidy-text
                style="margin-right: 5px;"
                class="day-text"
              [body]="day.shortMonth + ' '" />
            }
            @if (day.isToday) {
              <div class="today-background-container">
                <div class="today-background"></div>
                <tidy-text class="day-text" [body]="day.date" />
              </div>
            } @else {
              <tidy-text class="day-text" [body]="day.date" />
            }
          </div>
        </div>
        @if (day.ownerBlocks?.length === 1) {
          <app-owner-block-card
            class="owner-block-month-bar"
            variant="bar"
            [block]="day.ownerBlocks[0]"
            [address]="day.ownerBlocks[0].propertyName"
            [showLabel]="windowWidth >= 820" />
        } @else if (day.ownerBlocks?.length > 1) {
          <div
            class="owner-block-month-strip"
            [attr.id]="day.popupLeft ? 'hover-trigger-left' : 'hover-trigger-right'"
            (click)="$event.stopPropagation()">
            <div class="align-center">
              <span class="owner-block-preview-lock small"></span>
              @if (windowWidth >= 820) {
                <tidy-text [body]="day.ownerBlockText" />
              }
              <div
                [class]="!day.isFirstWeek ? 'popup' : 'popup popup-first-week'"
                id="popup-content">
                <div class="popup-content">
                  <div class="container vertical-align-center">
                    <span class="owner-block-preview-lock small" style="margin-right: 5px;"></span>
                    <tidy-text [header]="'Blocked Dates'" />
                  </div>
                  <div class="divider"></div>
                  @for (block of day.ownerBlocks | slice: 0:4; track block.id; let i = $index) {
                    <div
                      [class]="i === 0 ? 'container' : 'container bullet-item'">
                      <app-owner-block-card
                        variant="row"
                        [block]="block"
                        [address]="block.propertyName" />
                    </div>
                  }
                  @if (day.ownerBlocks?.length > 4) {
                    <div class="container bullet-item">
                      <tidy-text
                      [body]="'+' + (day.ownerBlocks.length - 4) + (' more' | translate)" />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (day.filteredJobs.length !== 0 || !isLoading) {
          @if ((day.filteredReservations?.length > 0 || day.filteredInquiries?.length > 0) && day.filteredJobs?.length > 0) {
            <div style="margin-top: 1rem"></div>
          }
          @for (job of day.filteredJobs | slice: 0:totalJobsToShow; track job; let i = $index) {
            <div
              class="job-container"
              [attr.id]="day.popupLeft ? 'hover-trigger-left' : 'hover-trigger-right'"
              (click)="onClickJob(job)">
              <div class="align-center">
                <div>
                  @if (job?.status?.icon_type === 'image') {
                    <tidy-image
                      [src]="job?.status?.icon"
                      style="height: 15px" />
                  }
                </div>
                @if (job?.status?.icon_type === 'initials') {
                  <div
                    [ngStyle]="job?.status?.status === 'on_the_way' || job?.status?.status === 'arrived_at_home' ? {'margin-right': '8px'} : {}">
                    <tidy-initials-icon
                      [size]="'small'"
                      [fullName]="job?.title || job?.homekeeperName || 'BA'" />
                  </div>
                }
                <tidy-text
                  [ngStyle]="{'margin-left': job?.status?.class === 'pro-initials-in-progress' ? '5px' : '0px'}"
                  [body]="windowWidth <= 1330 ? ((job?.address?.address_name || job?.address?.address1) | truncate: jobNameTruncateLength) : job?.address?.address_name || job?.address?.address1" />
              </div>
              <div class="popup" id="popup-content">
                <div class="popup-content">
                  <div class="container vertical-align-center">
                    <tidy-image [src]="job?.icon" class="body-size" />
                    <tidy-text
                      [header]="job?.object?.service_name || job?.object?.service_type_details?.name" />
                  </div>
                  <div class="divider"></div>
                  <div class="container">
                    <tidy-text
                    [body]="job?.parsedRequestTimes ? job?.parsedRequestTimes : ((job?.date | translate) + ' ' + (job?.time | translate))" />
                  </div>
                  @if (job?.homekeeperNames) {
                    <div
                      class="container bullet-item"
                      >
                      <tidy-text [body]="job?.homekeeperNames" />
                    </div>
                  } @else {
                    @if (job?.object?.homekeeper?.name) {
                      <div
                        class="container bullet-item"
                        >
                        <tidy-text
                        [body]="job?.object?.homekeeper?.name" />
                      </div>
                    }
                  }
                  <div class="container bullet-item">
                    <tidy-text
                    [body]="job?.address?.address_name || job?.address?.address1" />
                  </div>
                  <div class="container bullet-item">
                    <tidy-text
                    [body]="job?.status?.name | titlecase" />
                  </div>
                </div>
              </div>
            </div>
          }
          @if (day.filteredJobs.length > totalJobsToShow) {
            <div class="job-container">
              <div class="align-center more-jobs">
                <tidy-text
                [body]="'+' + day.filteredJobs.length - totalJobsToShow + (' more' | translate)" />
              </div>
            </div>
          }
        }
        @if ((day.filteredJobs.length === 0 && isLoading && !day.otherMonth)) {
          <div style="margin-top: 1rem">
            <ion-skeleton-text
              animated="true"
              style="
                height: 16px;
                border-radius: 6px;
                width: 100%;
              " />
          </div>
          @if (totalJobsToShow > 1) {
            <div>
              <ion-skeleton-text
                animated="true"
              style="
                height: 16px;
                border-radius: 6px;
                width: 100%;
              " />
            </div>
          }
          <div>
            <ion-skeleton-text
              animated="true"
              style="
                height: 16px;
                border-radius: 6px;
                width: 40%;
              " />
          </div>
        }
      </div>
    }
  </div>
  }
</div>